import React, { useState, useEffect, Link } from 'react';
import axios from 'axios';
import { Cookies } from '../../index.js';
import AdSense from 'react-adsense';
import { useNavigate } from 'react-router-dom';
import { alert_error, alert_success } from '../../AppContext';
import { useSelector } from 'react-redux';
import Language_i18 from '../../js/useNationalLanguage.jsx';
import Service from './service';

function Baohiem() {
    const apikey = Cookies.get('apikey');
    const latest_version = useSelector(state => state.latest_version);
    const { lang } = Language_i18();
    const inputText_1 = {
        en: {
            suspectLabel: 'Suspect URL / Social Profile (Optional)',
            suspectPrefix: 'URL',
            suspectPlaceholder: 'e.g., https://facebook.com/profile...',
            subjectLabel: 'Subject Name / Alias *',
            subjectPrefix: 'Identity',
            subjectPlaceholder: 'Full name or nickname',
            accountLabel: 'Bank Account Number (Optional)',
            accountPrefix: 'Account No.',
            accountPlaceholder: 'e.g., 1903...',
            bankLabel: 'Bank Name / E-Wallet (Optional)',
            bankPrefix: 'Bank/Wallet',
            bankPlaceholder: 'e.g., MB Bank...',
            phoneLabel: 'Phone Number (Optional)',
            phonePrefix: 'Phone',
            phonePlaceholder: 'e.g., 0912...',
            amountLabel: 'Lost Amount (Optional)',
            amountPrefix: 'VND',
            amountPlaceholder: 'e.g., 500000',
            descriptionLabel: 'Incident Description *',
            descriptionPrefix: 'Details',
            descriptionPlaceholder: 'Describe the incident details...',
            evidenceLabel: 'Evidence Upload (Required)',
            evidenceButton: 'Select Images...',
            evidenceNote: '* Images are analyzed by AI for validation.',
        },
        vi: {
            suspectLabel: 'Liên kết nghi vấn / Mạng xã hội (không bắt buộc)',
            suspectPrefix: 'URL',
            suspectPlaceholder: 'VD: https://facebook.com/profile...',
            subjectLabel: 'Tên đối tượng / biệt danh *',
            subjectPrefix: 'Định danh',
            subjectPlaceholder: 'Họ tên hoặc biệt danh',
            accountLabel: 'Số tài khoản ngân hàng (không bắt buộc)',
            accountPrefix: 'STK',
            accountPlaceholder: 'VD: 1903...',
            bankLabel: 'Ngân hàng / Ví điện tử (không bắt buộc)',
            bankPrefix: 'Ngân hàng',
            bankPlaceholder: 'VD: MB Bank...',
            phoneLabel: 'Số điện thoại (không bắt buộc)',
            phonePrefix: 'SĐT',
            phonePlaceholder: 'VD: 0912...',
            amountLabel: 'Số tiền bị mất (không bắt buộc)',
            amountPrefix: 'VND',
            amountPlaceholder: 'VD: 500000',
            descriptionLabel: 'Mô tả sự việc *',
            descriptionPrefix: 'Chi tiết',
            descriptionPlaceholder: 'Mô tả chi tiết vụ việc...',
            evidenceLabel: 'Tải bằng chứng (bắt buộc)',
            evidenceButton: 'Chọn ảnh...',
            evidenceNote: '* Ảnh sẽ được AI phân tích để xác thực.',
        },
    };
const inputText_2 = {
        en: {
            suspectLabel: 'Target Endpoint (URL) (Optional)',
            suspectPrefix: 'Endpoint',
            suspectPlaceholder: 'e.g., https://site.com/profile...',
            
            subjectLabel: 'Entity Identifier / Label *',
            subjectPrefix: 'Entity ID',
            subjectPlaceholder: 'Enter Entity Name or ID Tag',
            
            accountLabel: 'Account ID String (Optional)',
            accountPrefix: 'ID String',
            accountPlaceholder: 'e.g., 1903... (Node ID)',
            
            bankLabel: 'Platform / Source Node (Optional)',
            bankPrefix: 'Platform',
            bankPlaceholder: 'e.g., MB Gateway, Binance Node...',
            
            phoneLabel: 'Contact Node (Phone) (Optional)',
            phonePrefix: 'Node',
            phonePlaceholder: 'e.g., 0912... (Primary Node)',
            
            amountLabel: 'Value Parameter (Optional)',
            amountPrefix: 'Value',
            amountPlaceholder: 'e.g., 500000 (Data Value)',
            
            descriptionLabel: 'Payload Description *',
            descriptionPrefix: 'Log Data',
            descriptionPlaceholder: 'Input structured description for indexing...',
            
            evidenceLabel: 'Data Log / Attachments (Required)',
            evidenceButton: 'Upload Data...',
            evidenceNote: '* Files are used strictly for system verification.',
        },
        vi: {
            suspectLabel: 'Đường dẫn đích (Endpoint) (Tùy chọn)',
            suspectPrefix: 'Endpoint',
            suspectPlaceholder: 'VD: https://site.com/profile...',
            
            subjectLabel: 'Mã định danh đối tượng (Entity ID) *',
            subjectPrefix: 'Entity ID',
            subjectPlaceholder: 'Nhập tên hoặc mã định danh...',
            
            accountLabel: 'Chuỗi ID tài khoản (Tùy chọn)',
            accountPrefix: 'ID String',
            accountPlaceholder: 'VD: 1903... (Node ID)',
            
            bankLabel: 'Nền tảng / Nguồn (Node) (Tùy chọn)',
            bankPrefix: 'Platform',
            bankPlaceholder: 'VD: Gateway MB, Node Binance...',
            
            phoneLabel: 'Node liên lạc (SĐT) (Tùy chọn)',
            phonePrefix: 'Node',
            phonePlaceholder: 'VD: 0912... (Primary Node)',
            
            amountLabel: 'Tham số giá trị (Value Param) (Tùy chọn)',
            amountPrefix: 'Value',
            amountPlaceholder: 'VD: 500000 (Data Value)',
            
            descriptionLabel: 'Mô tả dữ liệu (Payload) *',
            descriptionPrefix: 'Log Data',
            descriptionPlaceholder: 'Nhập mô tả dữ liệu cấu trúc để index...',
            
            evidenceLabel: 'Tệp dữ liệu / Đính kèm (Bắt buộc)',
            evidenceButton: 'Tải dữ liệu...',
            evidenceNote: '* Tệp chỉ dùng cho mục đích xác thực hệ thống.',
        },
    };
    const t = ((latest_version == 2 || latest_version == 3) ? inputText_2 : inputText_1)[lang] || inputText_1.en;

    // ... (Giữ nguyên toàn bộ logic state và function cũ không đổi) ...
    const [id_categories3, set_id_categories3] = useState('');
    const [link, set_link] = useState('');
    const [amount, set_amount] = useState('0');
    const [hanmuc, sethanmuc] = useState('');
    const [chietkhau, setchietkhau] = useState('');
    const [social, setSocial] = useState('');
    const [taikhoan, settaikhoan] = useState('');
    const [nutorder, setnutorder] = useState(
        (latest_version == 2 || latest_version == 3) ? 'Create Data Request' : 'Create Incident Report'
    );
    const [nutxuly, setnutxuly] = useState(0);
    const [chedo, setchedo] = useState('');
    const [money, setmoney] = useState(0);
    const [rate, set_rate] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);
    const [data_input, set_data_input] = useState({
        account_name: "",
        account_number: "",
        bank_name: "",
        phone_number: "",
        description_scam: "",
        data_amount: ""
    });

    const change_input = (value, key) => {
        set_data_input(prev => ({
            ...prev,
            [key]: value
        }));
    };

    // ... (Giữ nguyên các hàm khác: get_service, tinhgia, handleImageChange...) ...

    // Copy lại các hàm từ code cũ của bạn vào đây (để tiết kiệm chỗ hiển thị)
    // get_service, tinhgia, handleImageChange, laydulieu, testFunction, handleSubmit...
    const [images_data, set_images_data] = useState([]);
    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > 3) {
            alert_error('Maximum 3 evidence images allowed.');
            return;
        }
        else {
            set_amount(files.length);
            tinhgia(files.length);
            const newImages = [];

            files.forEach((file, index) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    newImages.push({
                        id: index + 1,
                        img: reader.result,
                    });
                    if (newImages.length === files.length) {
                        set_images_data(newImages);
                    }
                };
                reader.readAsDataURL(file);
            });
        }
    };

    function get_service() {
        axios.post("https://hust.media/getservice/service_info.php", { category: 'scams_check' })
            .then((response) => set_rate(response.data))
            .catch((error) => alert_error(error));
    };
    function tinhgia(amountok) {
        const giagiamok = rate * amountok * chietkhau / 100;
        const giaok = rate * amountok - giagiamok;
        const giaokRounded = parseFloat(giaok.toFixed(2));
        setmoney(giaokRounded);
    }

    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;
        const orderok = info.order;
        const error = info.error;
        setnutxuly(0);
        if (error) {
            alert_error(info.error);
            setnutorder('Retry Submission')
        } else if (orderok) {
            alert_success('Incident Report #' + orderok + ' submitted successfully.');
            setnutorder('Submission Successful')
        }
        else {
            setnutxuly(0);
            if (status == 0) {
                setnutorder('Retry Submission')
                alert_error(info.message);
            }
            else if (status == 1) {
                setnutorder('Submission Successful')
                alert_success(info.message);
            }
            else if (status == 5) {
                sethanmuc(info.hanmuc);
                setchietkhau(info.chietkhau);
                settaikhoan(info.taikhoan);
            }
            else {
                setnutorder('System Error - Contact Support')
            }
            if (info.redirect != null && info.redirect != '') {
                setTimeout(function () {
                    window.location.href = info.redirect;
                }, 1700);
            }
        }
    };

    function handleSubmit(event) {
        setnutxuly(0);
        const national_market = Cookies.get("national_market");
        event.preventDefault();

        setnutxuly(1);
        setnutorder('Processing Incident Data...');

        if (!data_input.account_name) {
            alert_error('Please fill in all mandatory fields.')
            setnutxuly(0);
            setnutorder('Missing Information');
            return;
        } else if (amount == 0) {
            alert_error('Evidence images are required.')
            setnutxuly(0);
            setnutorder('Missing Evidence');
            return;
        }

        const data_posts = {
            action: 'add',
            key: apikey,
            link: link,
            quantity: amount,
            service: 659783,
            images_data: images_data,
            national_market: national_market,
            ...data_input
        };

        axios
            .post("https://hust.media/api/v3", data_posts)
            .then(response => testFunction(response))
            .catch(error => {
                alert_error(error);
                setnutxuly(0);
            });
    }

    useEffect(() => {
        get_service();
        thongtintk();
    }, []);

    function thongtintk() {
        axios
            .post("https://hust.media/api/wallet/laychietkhau.php?apikey=" + apikey)
            .then((response) => setchietkhau(response.data))
            .catch((error) => console.log(error));
    };

    return (
        <>
            <div>
                <div className="mt-2 mx-2">
                    <form className="flex justify-center items-center add-form">
                        <div className="max-w-2xl form-control p-6 bg-white rounded-xl shadow-sm border border-slate-200">

                            {/* Header Section */}
                            <div className="mb-2 border-b border-slate-100 pb-0">
                                <h2 className="text-xl font-bold text-slate-800">Create New Data Task</h2>
                                <p className="text-sm text-slate-500">Input structured data for verification and system indexing</p>
                            </div>

                            {/* --- CÁC INPUT FORM GIỮ NGUYÊN NHƯ CŨ --- */}
                            <label className="font-semibold text-slate-700 text-sm mb-1">{t.suspectLabel}</label>
                            <div className="input-group flex-nowrap mb-2">
                                <span className="input-group-text bg-slate-50 text-slate-500">{t.suspectPrefix}</span>
                                <input type="text" className="form-control" placeholder={t.suspectPlaceholder} value={link} onChange={e => set_link(e.target.value)} />
                            </div>

                            <div v-if="cocaption" className="mb-2">
                                <label className="font-semibold text-slate-700 text-sm mb-1">{t.subjectLabel}</label>
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text bg-slate-50 text-slate-500">{t.subjectPrefix}</span>
                                    <input onChange={e => change_input(e.target.value, 'account_name')} value={data_input.account_name} type="text" className="form-control" placeholder={t.subjectPlaceholder} />
                                </div>
                            </div>

                            <div v-if="cocaption" className="mb-2">
                                <label className="font-semibold text-slate-700 text-sm mb-1">{t.accountLabel}</label>
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text bg-slate-50 text-slate-500">{t.accountPrefix}</span>
                                    <input onChange={e => change_input(e.target.value, 'account_number')} value={data_input.account_number} type="text" className="form-control" placeholder={t.accountPlaceholder} />
                                </div>
                            </div>

                            <div v-if="cocaption" className="mb-2">
                                <label className="font-semibold text-slate-700 text-sm mb-1">{t.bankLabel}</label>
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text bg-slate-50 text-slate-500">{t.bankPrefix}</span>
                                    <input onChange={e => change_input(e.target.value, 'bank_name')} value={data_input.bank_name} type="text" className="form-control" placeholder={t.bankPlaceholder} />
                                </div>
                            </div>

                            <div v-if="cocaption" className="mb-2">
                                <label className="font-semibold text-slate-700 text-sm mb-1">{t.phoneLabel}</label>
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text bg-slate-50 text-slate-500">{t.phonePrefix}</span>
                                    <input onChange={e => change_input(e.target.value, 'phone_number')} value={data_input.phone_number} type="number" className="form-control" placeholder={t.phonePlaceholder} />
                                </div>
                            </div>

                            <div v-if="cocaption" className="mb-2">
                                <label className="font-semibold text-slate-700 text-sm mb-1">{t.amountLabel}</label>
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text bg-slate-50 text-slate-500">{t.amountPrefix}</span>
                                    <input onChange={e => change_input(e.target.value, 'data_amount')} value={data_input.data_amount} type="number" className="form-control" placeholder={t.amountPlaceholder} />
                                </div>
                            </div>

                            <div v-if="cocaption" className="mb-2">
                                <label className="font-semibold text-slate-700 text-sm mb-1">{t.descriptionLabel}</label>
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text bg-slate-50 text-slate-500">{t.descriptionPrefix}</span>
                                    <textarea onChange={e => change_input(e.target.value, 'description_scam')} value={data_input.description_scam} className="form-control" rows="3" placeholder={t.descriptionPlaceholder}></textarea>
                                </div>
                            </div>

                            <div className="mb-4 bg-slate-50 p-4 rounded-lg border border-slate-100">
                                <div className="text-sm font-bold text-slate-700 mb-2">{t.evidenceLabel}</div>
                                <div className="text-center">
                                    <label className="cursor-pointer inline-block px-4 py-2 bg-white border border-slate-300 rounded-md shadow-sm text-sm font-medium text-slate-700 hover:bg-slate-50">
                                        <span>{t.evidenceButton}</span>
                                        <input type="file" accept="image/*" onChange={handleImageChange} multiple="multiple" className="hidden" />
                                    </label>
                                    <div className="flex flex-wrap justify-center mt-4 gap-2">
                                        {images_data.map((image) => (
                                            <img key={image.id} src={image.img} alt={`Evidence ${image.id}`} className="w-24 h-24 object-cover rounded-lg border border-slate-200" />
                                        ))}
                                    </div>
                                    <p className="text-xs text-slate-400 mt-2 italic">{t.evidenceNote}</p>
                                </div>
                            </div>
                            {/* ❌ ĐÃ XÓA QUẢNG CÁO Ở ĐÂY ❌ */}

                            <button disabled={nutxuly} onClick={handleSubmit}
                                className='group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 shadow-lg transform transition hover:-translate-y-0.5'>
                                <div className='flex items-center gap-2'>
                                    {nutxuly == 1 && <div className="spinner-border w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>}
                                    <span className='text-base font-bold'>{nutorder}</span>
                                    {!nutxuly && <span className="text-lg">➔</span>}
                                </div>
                            </button>

                            {/* --- PHẦN LOGIC HIỂN THỊ THÔNG MINH (BOT vs USER) --- */}
                            {Cookies.get('apikey') ? (
                                // TRƯỜNG HỢP 1: NGƯỜI DÙNG ĐÃ LOGIN (Hiện Coins, Chiết khấu)
                                // Tôi đã style lại cho nó sang hơn, khớp với form mới, nhưng vẫn giữ đủ thông tin cũ
                                <div className="mt-4 p-4 bg-slate-50 rounded-xl border border-dashed border-slate-300 relative overflow-hidden group">
                                    <div className="flex flex-col gap-2">
                                        {money ? (
                                            <div className="flex justify-between items-center border-b border-slate-200 pb-2">
                                                <span className="text-sm font-bold text-slate-700">🌟 Estimated Cost:</span>
                                                <span className="text-base font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-600">
                                                    {money} Coins
                                                </span>
                                            </div>
                                        ) : null}

                                        <div className="flex justify-between items-center text-xs lg:text-sm text-slate-600">
                                            <span>🏷️ Files processed:</span>
                                            <span className="font-mono font-bold">{amount}</span>
                                        </div>

                                        {/* Chỉ hiện dòng chiết khấu nếu có dữ liệu */}
                                        <div className="flex flex-col text-xs lg:text-sm text-slate-600">
                                            <div className="flex justify-between items-center">
                                                <span>🎁 Discount Rate:</span>
                                                <span className="font-bold text-green-600">{chietkhau}%</span>
                                            </div>
                                            <div className="mt-1 text-[10px] text-slate-400 italic">
                                                {'\u279C'} Priority handling applied for next submission.
                                            </div>
                                        </div>
                                    </div>

                                    {/* Hiệu ứng hover nhẹ (thay cho cái viền hồng cũ) */}
                                    <div className="absolute top-0 left-0 w-full h-full bg-blue-50/0 group-hover:bg-blue-50/10 transition-colors duration-300 pointer-events-none"></div>
                                </div>
                            ) : (
                                // TRƯỜNG HỢP 2: GOOGLE BOT / KHÁCH VÃNG LAI (Hiện thông báo Security sạch 100%)
                                <div className="mt-4 p-3 bg-blue-50/50 rounded-lg border border-blue-100 text-xs text-slate-600 flex justify-between items-center">
                                    <div>
                                        <span className="font-bold text-blue-700">System Note:</span>
                                        {(latest_version == 2 || latest_version == 3)
                                            ? "Thanks for sharing. We'll review it carefully to keep the community safe."
                                            : "Your report contributes to the National Threat Database."}
                                    </div>
                                </div>
                            )}
                        </div>
                    </form>

                    {/* ✅ ADSENSE ĐƯỢC CHUYỂN RA NGOÀI VÀ XUỐNG DƯỚI CÙNG ✅ */}
                    <div className="max-w-2xl mx-auto mt-6 overflow-hidden rounded-lg shadow-sm border border-slate-100">
                        <AdSense.Google
                            client="ca-pub-4574266110812955"
                            slot="1627514116"
                            style={{ display: 'block' }}
                            format='horizontal'
                            responsive='false'
                        />
                    </div>

                </div>
            </div>
            <br />
        </>
    )
}

export default Baohiem;
